import { useState, useContext } from "react";
import { useRCAMainStyles } from "../RCA.styles";
import { useTranslation } from "react-i18next";
import { Tab, Tabs, Typography } from "@mui/material";
import RCACorporateDashboardFilters from "./components/filters/RCACorporateDashboardFilters/RCACorporateDashboardFilters.view";
import { useStyles } from "./RCACorporateDashboard.styles";
import { RCACorporateDashboardContext } from "contexts/RCACorporateDashboardContext/RCACorporateDashboardContext";
import RCACompliance from "./RCACompliance";
import APCompliance from "./APCompliance";
import { ComplianceTypes } from "constants/constants";

enum TabsEnum {
    rcaCompliance,
    actionPlanCompliance,
}

const RCACorporateDashboard = () => {
    const mainClasses = useRCAMainStyles();
    const classes = useStyles();
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState(TabsEnum.rcaCompliance);
    const { handleSetComplianceType } = useContext(RCACorporateDashboardContext);

    const tabs = [
        {
            id: TabsEnum.rcaCompliance,
            label: t("rca.compliance.tabs.rca_compliance"),
        },
        {
            id: TabsEnum.actionPlanCompliance,
            label: t("rca.compliance.tabs.ap_compliance"),
        },
    ];

    const tabsComponents = {
        [TabsEnum.rcaCompliance]: { component: <RCACompliance /> },
        [TabsEnum.actionPlanCompliance]: { component: <APCompliance /> },
    };

    return (
        <div className={mainClasses.mainWrapper}>
            <div className={classes.contentTitleContainer}>
                <Typography variant="rcaTitle" className={mainClasses.contentTitle}>
                    {t("rca.corporate_dashboard.title")}
                </Typography>
                <RCACorporateDashboardFilters />
            </div>
            <div className={classes.mainWrapper}>
                <Tabs
                    className={classes.tabs}
                    value={selectedTab}
                    onChange={(_, newValue) => {
                        setSelectedTab(newValue);
                        handleSetComplianceType(ComplianceTypes.NONE);
                    }}
                >
                    <Tab value={TabsEnum.rcaCompliance} label={tabs[TabsEnum.rcaCompliance].label} />
                    <Tab value={TabsEnum.actionPlanCompliance} label={tabs[TabsEnum.actionPlanCompliance].label} />
                </Tabs>
                <div>
                    {
                        // @ts-ignore
                        tabsComponents[selectedTab].component
                    }
                </div>
            </div>

            <div className={mainClasses.contentWrapper}></div>
        </div>
    );
};

export default RCACorporateDashboard;
